<template>
    <v-dialog v-model="isOpen" max-width="800px" persistent>
        <v-card class="pa-4" id="form-scroll-container">
            <v-card-title class="headline text-orange-darken-2 pb-2">
                <div class="d-flex align-center">
                    <v-icon left class="mr-2" color="#1D1B59">fas fa-pen</v-icon>
                    {{ $t("views.trips.create_trip.edit_stop") }}
                </div>
                <v-btn icon @click="$emit('close')" class="ml-auto">
                    <v-icon color="#1D1B59">fas fa-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider class="mb-4" />
            <v-card-text>
                <v-row dense>
                    <v-col cols="12">
                        <v-text-field v-model="stop.number_order" :label="$t('views.trips.create_trip.number_order')"
                            outlined dense />
                    </v-col>
                    <v-col cols="12">
                        <v-radio-group v-model="stop.type_location" row>
                            <v-radio :label="$t('views.trips.create_trip.origin')" value="origen" />
                            <v-radio :label="$t('views.trips.create_trip.destination')" value="destino" />
                        </v-radio-group>
                    </v-col>
                    <v-col cols="6">
                        <v-combobox v-model="stop.description_company_client" :items="clientNames"
                            :label="$t('views.trips.create_trip.client_desc')" outlined dense clearable
                            @focus="setActiveScroll('client')" @change="onClientDescriptionSelected" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="stop.id_company_client" :label="$t('views.trips.create_trip.client_id')"
                            outlined dense :readonly="clientDescriptionExists" />
                    </v-col>
                    <v-col cols="6">
                        <v-combobox v-model="stop.description_location_destiny" :items="FilteredLocations"
                            :label="$t('views.trips.create_trip.location_code')" outlined dense clearable
                            :search-input.sync="searchLocation" @focus="setActiveScroll('location')"
                            @change="onLocationSelected" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="stop.code_location_destiny"
                            :label="$t('views.trips.create_trip.code_location')" outlined dense
                            :readonly="localityExists" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="stop.latitude" :label="$t('views.trips.create_trip.latitude')" outlined
                            dense :readonly="localityExists" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="stop.longitude" :label="$t('views.trips.create_trip.longitude')" outlined
                            dense :readonly="localityExists" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="stop.code_city" :label="$t('views.trips.create_trip.city_code')" outlined
                            dense :readonly="localityExists" />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="stop.code_deparment"
                            :label="$t('views.trips.create_trip.department_code')" outlined dense
                            :readonly="localityExists" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="stop.datetime_in_place"
                            :label="$t('views.trips.create_trip.scheduled_date')" type="datetime-local" outlined
                            dense />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="stop.remission" :label="$t('views.trips.create_trip.remission')" outlined
                            dense />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="stop.shipment_number"
                            :label="$t('views.trips.create_trip.shipment_number')" outlined dense />
                    </v-col>
                    <v-col cols="6">
                        <v-combobox v-model="stop.businessUnit"
                            :items="businessUnits.map(b => b.description)"
                            :label="$t('views.trips.create_trip.business_description')" outlined dense clearable
                            @focus="loadBusinessUnits" @change="handleBusinessUnitSelected" />
                    </v-col>

                    <v-col cols="6">
                        <v-text-field v-model="stop.code_businessunit"
                            :label="$t('views.trips.create_trip.business_unit')" outlined dense
                            :readonly="businessUnitExist" />
                    </v-col>

                    <!-- Descripción del canal de ventas -->
                    <v-col cols="6">
                        <v-combobox v-model="stop.name_location_seller"
                            :items="salesChannels.map(c => c.description)"
                            :label="$t('views.trips.create_trip.sales_description')" outlined dense clearable
                            @focus="loadSalesChannels" @change="handleSalesChannelSelected" />
                    </v-col>

                    <!-- Código del canal (readonly) -->
                    <v-col cols="6">
                        <v-text-field v-model="stop.code_location_seller"
                            :label="$t('views.trips.create_trip.sales_channel')" outlined dense
                            :readonly="salesChannelExist" />
                    </v-col>


                    <!-- Tipo de Producto -->
                    <v-col cols="6">
                        <v-combobox v-model="stop.name_zone" :items="productTypes.map(p => p.description)"
                            :label="$t('views.trips.create_trip.product_type')" outlined dense clearable
                            @focus="loadProductTypes" @change="handleProductTypeSelected" />
                    </v-col>

                    <v-col cols="6">
                        <v-text-field v-model="stop.code_zone" :label="$t('views.trips.create_trip.product_type_code')"
                            outlined dense :readonly="ProductTypeExists" />
                    </v-col>


                    <!-- CommodityType -->
                    <v-col cols="6">
                        <v-combobox v-model="stop.type_commodity"
                            :items="commodityTypes.map(c => c.description)"
                            :label="$t('views.trips.create_trip.goods_type')" outlined dense clearable
                            @focus="loadCommodityTypes" @change="handleCommodityTypeSelected" />
                    </v-col>

                    <v-col cols="6">
                        <v-text-field v-model="stop.code_type_commodity"
                            :label="$t('views.trips.create_trip.goods_type_code')" outlined dense
                            :readonly="MerchandiseTypeExists" />
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete v-model="stop.description_state_order" :items="statesMerchandise"
                            :label="$t('views.trips.create_trip.goods_status')" outlined dense clearable />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-btn text color="grey darken-1" @click="$emit('close')">
                    {{ $t("views.trips.create_trip.cancel") }}
                </v-btn>
                <v-btn color="orange darken-2" dark @click="save">
                    {{ $t("views.trips.create_trip.save") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import debounce from 'lodash/debounce';
import { toDatetimeLocalFormat } from "@/plugins/dateUtils";
export default {
    name: 'EditStopModal',
    props: {
        isOpen: Boolean,
        initialStop: Object,
        statesMerchandise: Array,
        idCompanyParent: {
            type: Number,
            required: true,
        }
    },
    emits: ['save', 'close'],
    data() {

        return {
            stop: { ...this.initialStop },
            clients: [],
            // Estados y validaciones
            localityExists: true,
            clientDescriptionExists: true,
            ProductTypeExists: true,
            MerchandiseTypeExists: true,
            salesChannelExist: true,
            businessUnitExist: true,
            locations: [],
            searchLocation: '',
            clientPage: 1,
            totalClientPages: null,
            locationPage: 1,
            totalLocationPages: null,
            loadingScroll: { client: false, location: false },
            activeScrollId: null,
            showLocationModal: false,
            businessUnits: [],
            businessUnitsLoaded: false,
            salesChannels: [],
            salesChannelsLoaded: false,
            productTypes: [],
            commodityTypes: [],
            productTypesLoaded: false,
            commodityTypesLoaded: false,
        };
    },
    computed: {
        FilteredLocations() {
            const raw = this.searchLocation == null ? '' : this.searchLocation
            const search = String(raw).toLowerCase().trim()
            const list = this.locations
                .filter(l => l.description.toLowerCase().includes(search))
                .map(l => l.description);
            return list.length
                ? list
                : [`${this.searchLocation}`];
        },
        clientNames() {
            return this.clients.map(c => c.businessName);
        }
    },
    watch: {
        initialStop(newVal) {
            this.stop = { ...newVal };
            this.stop.datetime_in_place = toDatetimeLocalFormat(this.stop.datetime_in_place);
        },
        searchLocation: {
            handler: debounce(function (value) {
                if (!this.stop.id_company_client) return;

                this.locationPage = 1;
                this.locations = [];

                const description = value?.trim() || "";
                this.loadLocations(description);
            }, 500),
            immediate: false,
        }
    },
    mounted() {
        this.loadClients();
    },
    methods: {
        save() {
            this.$emit('save', { ...this.stop });
            this.$emit('close');
        },
        setActiveScroll(id) {
            this.activeScrollId = id;

            if (id === 'location' && this.locations.length === 0) {
                this.loadLocations();
            }

            this.pollForDropdownScrollListener(id);
        },
        pollForDropdownScrollListener(id) {
            const interval = setInterval(() => {
                const menus = document.querySelectorAll('.v-menu__content');
                menus.forEach(menu => {
                    if (menu.dataset[`scrollAttached_${id}`]) return;
                    if (this.activeScrollId !== id) return;
                    menu.dataset[`scrollAttached_${id}`] = 'true';
                    menu.addEventListener('scroll', (e) => this.handleScroll(e, id));
                });
            }, 500);
            setTimeout(() => clearInterval(interval), 5000);
        },
        handleScroll(e, id) {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            if (scrollTop + clientHeight >= scrollHeight - 50) {
                if (this.loadingScroll[id]) return;
                this.loadingScroll[id] = true;
                if (id === 'client') this.loadClients();
                if (id === 'location') this.loadLocations();
                this.loadingScroll[id] = false;
            }
        },
        async loadClients() {
            try {
                const size = 50;
                const res = await this.axios.get(`/Customer/Companies/${this.clientPage}/${size}`);
                const data = res.data || [];

                if (data.length < size) this.totalClientPages = this.clientPage;
                this.clients.push(...data);
            } catch (error) {
                console.error("Error loading clients:", error);
            }
        },
        async loadLocations(description = "") {
            try {
                const size = 50;
                const nit = this.stop.id_company_client;

                if (!nit) return;

                const page = this.locationPage;
                const baseUrl = `/Location/${nit}/${page}/${size}`;
                const url = description.trim()
                    ? `${baseUrl}?description=${encodeURIComponent(description.trim())}`
                    : baseUrl;

                const res = await this.axios.get(url);
                const data = res.data || [];

                if (data.length < size) this.totalLocationPages = page;
                this.locations.push(...data);
            } catch (error) {
                console.error("Error loading locations:", error);
            }
        },
        async loadBusinessUnits() {
            if (this.businessUnitsLoaded) return;

            try {
                const res = await this.axios.get(`/BusinessUnits/ByIdCompay/${this.idCompanyParent}`);
                this.businessUnits = res.data || [];
                this.businessUnitsLoaded = true;
            } catch (error) {
                console.error("Error loading business units:", error);
            }
        },
        async loadSalesChannels() {
            if (this.salesChannelsLoaded) return;

            try {
                const res = await this.axios.get(`/Channel/ByIdCompay/${this.idCompanyParent}`);
                this.salesChannels = res.data || [];
                this.salesChannelsLoaded = true;
            } catch (error) {
                console.error("Error loading sales channels:", error);
            }
        },
        async loadProductTypes() {
            if (this.productTypesLoaded) return;
            try {
                const res = await this.axios.get(`/Product/TypeProduct/${this.idCompanyParent}`);
                this.productTypes = res.data || [];
                this.productTypesLoaded = true;
            } catch (err) {
                console.error("Error loading product types:", err);
            }
        },

        async loadCommodityTypes() {
            if (this.commodityTypesLoaded) return;
            try {
                const res = await this.axios.get(`/Merchandise/GetAll/${this.idCompanyParent}`);
                this.commodityTypes = res.data || [];
                this.commodityTypesLoaded = true;
            } catch (err) {
                console.error("Error loading commodity types:", err);
            }
        },
        onLocationSelected(value) {
            const loc = this.locations.find(l => l.description === value);
            if (loc) {
                this.stop.description_location_destiny = loc.description;
                this.stop.code_location_destiny = loc.code_location;
                this.stop.latitude = loc.latitudeAddress;
                this.stop.longitude = loc.longitudeAddress;
                this.stop.code_city = loc.codeCity;
                this.stop.description_city = loc.nameCity;
                this.stop.address = loc.address || "";
                this.stop.code_deparment = loc.codeDepartment;
                this.stop.id_location = loc.idLocation;
                this.stop.id_city = loc.idCity;
                this.localityExists = true;
            } else {
                this.stop.code_location_destiny = '';
                this.localityExists = false;
            }
        },

        onClientDescriptionSelected(value) {
            const cliente = this.clients.find(c => c.businessName === value);
            this.stop.id_company_client = cliente?.identification || "";
            this.stop.type_company_client = cliente?.typeCompanie || "";
            this.clientDescriptionExists = !!cliente;
        },
        handleProductTypeSelected(description) {
            const selected = this.productTypes.find(p => p.description === description);
            this.stop.name_zone = selected?.description || description;
            this.stop.code_zone = selected?.code || "";
            this.ProductTypeExists = !!selected;
        },
        handleCommodityTypeSelected(description) {
            const selected = this.commodityTypes.find(c => c.description === description);
            this.stop.type_commodity = selected?.description || description;
            this.stop.code_type_commodity = selected?.code || "";
            this.MerchandiseTypeExists = !!selected;
        },
        handleSalesChannelSelected(description) {
            const selected = this.salesChannels.find(c => c.description === description);
            this.stop.name_location_seller = selected?.description || description;
            this.stop.code_location_seller = selected?.code_channel_WS || "";
            this.salesChannelExist = !!selected;
        },
        handleBusinessUnitSelected(description) {
            const selected = this.businessUnits.find(b => b.description === description);
            this.stop.businessUnit = selected?.description || description;
            this.stop.code_businessunit = selected?.codeBusinessUnitWS || "";
            this.businessUnitExist = !!selected;
        },
    }
};
</script>

<style lang="scss" scoped src="../../TripCreateForm.module.scss" />